import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'

import { AddressPipe } from './address.pipe'
import { BackgroundPCPipe } from './background-pc.pipe'
import { CardImagePipe } from './card-image.pipe'
import { CreditCardNumberPipe } from './credit-card-number.pipe'
import { CustomSectionsPipe } from './custom-sections.pipe'
import { DateOfBirthPipe } from './dob.pipe'
import { ExcerptPipe } from './excerpt.pipe'
import { FileSizePipe } from './filesize.pipe'
import { Html2TextPipe } from './html-to-text'
import { HumanNamePipe } from './human-name.pipe'
import { JoinPipe } from './join.pipe'
import { KeysPipe } from './keys.pipe'
import { LabelPCPipe } from './label-pc.pipe'
import { LanguageNamePipe } from './language-name.pipe'
import { LocalizedDatePipe } from './localized-date.pipe'
import { MomentDatePipe, MomentDateTimePipe, MomentTimePipe } from './moment.pipe'
import { MonthNumberPipe } from './month-number.pipe'
import { NoteTextPipe } from './note-text.pipe'
import { NoteTooltipPipe } from './note-tooltip.pipe'
import { OtherDropdownValuePipe } from './other-dropdown-value.pipe'
import { PhonePipe } from './phone'
import { QuestionLabelPipe } from './question-label.pipe'
import { RelativeTimePipe } from './relative-time.pipe'
import { ServiceReviewStatusTextToAuthStatusPipe, ServiceReviewStatusToAuthStatusPipe } from './service-review-status-to-authorization-status.pipe'
import { SexPipe } from './sex.pipe'
import { ShoppableServiceLabelsPipe } from './shoppable-service-labels.pipe'
import { ShortIdPipe } from './short-id.pipe'
import { StripHtmlPipe } from './striphtml'
import { TablePipe } from './table.pipe'
import { TitleCasePipe } from './titlecase'
import { ViewValuePipe } from './view-value.pipe'
import { WaitListCalculationPipe } from './wait-list-calculation'

const pipes = [
  AddressPipe,
  BackgroundPCPipe,
  CardImagePipe,
  CreditCardNumberPipe,
  CustomSectionsPipe,
  DateOfBirthPipe,
  ExcerptPipe,
  FileSizePipe,
  Html2TextPipe,
  HumanNamePipe,
  JoinPipe,
  KeysPipe,
  LabelPCPipe,
  LanguageNamePipe,
  LocalizedDatePipe,
  MomentDatePipe,
  MomentDateTimePipe,
  MomentTimePipe,
  MonthNumberPipe,
  NoteTextPipe,
  NoteTooltipPipe,
  OtherDropdownValuePipe,
  PhonePipe,
  QuestionLabelPipe,
  QuestionLabelPipe,
  RelativeTimePipe,
  ServiceReviewStatusToAuthStatusPipe,
  ServiceReviewStatusTextToAuthStatusPipe,
  SexPipe,
  ShoppableServiceLabelsPipe,
  ShortIdPipe,
  ShortIdPipe,
  StripHtmlPipe,
  TablePipe,
  TitleCasePipe,
  ViewValuePipe,
  WaitListCalculationPipe,
]

@NgModule({
  imports: [CommonModule],
  declarations: pipes,
  exports: pipes,
})
export class PipesModule {}
